import { createSagaAction } from '../../../../shared/sagas'
import { createReducer } from '../../../../shared/reducers'

// Constants
export const constants = {
  STOP_CALLS_REPORT_GET_JOB_LIST: createSagaAction('STOP_CALLS_REPORT_GET_JOB_LIST'),
  STOP_CALLS_REPORT_GET_ORGANIZATION_LIST: createSagaAction(
    'STOP_CALLS_REPORT_GET_ORGANIZATION_LIST'
  ),
  STOP_CALLS_REPORT_GET_FULL_REPORT: createSagaAction('STOP_CALLS_REPORT_GET_FULL_REPORT')
}

// Action Creators
export const actions = {
  stopCallsReportGetJobList: () => ({
    type: constants.STOP_CALLS_REPORT_GET_JOB_LIST.ACTION
  }),
  stopCallsReportGetOrganizationList: () => ({
    type: constants.STOP_CALLS_REPORT_GET_ORGANIZATION_LIST.ACTION
  }),
  stopCallsReportGetFullReport: ({ filters }) => ({
    type: constants.STOP_CALLS_REPORT_GET_FULL_REPORT.ACTION,
    filters
  })
}

// Reducer
const initialState = {}

export default createReducer(initialState, (state, action) => {
  switch (action.type) {
    case constants.STOP_CALLS_REPORT_GET_JOB_LIST.ACTION:
      return { ...state, error: null, loadingJobList: true }
    case constants.STOP_CALLS_REPORT_GET_JOB_LIST.SUCCESS:
      return { ...state, error: null, loadingJobList: false, jobList: action.payload }

    case constants.STOP_CALLS_REPORT_GET_ORGANIZATION_LIST.ACTION:
      return { ...state, error: null, loadingOrganizationList: true }
    case constants.STOP_CALLS_REPORT_GET_ORGANIZATION_LIST.SUCCESS:
      return {
        ...state,
        error: null,
        loadingOrganizationList: false,
        organizationList: action.payload
      }

    case constants.STOP_CALLS_REPORT_GET_FULL_REPORT.ACTION:
      return { ...state, error: null, loadingFullReport: true }
    case constants.STOP_CALLS_REPORT_GET_FULL_REPORT.SUCCESS:
      return {
        ...state,
        error: null,
        loadingFullReport: false,
        fullReport: action.payload
      }

    default:
      return state
  }
})



// WEBPACK FOOTER //
// ./src/redux/modules/reports/maintenance_dob/stopCallsReportActions.js